import * as React from 'react';
import * as I18n from 'i18n-js';
import {
  core_apimessages_Address as IAddress,
  core_apimessages_Country as ICountry,
  Countries,
} from '../../schemas/rql';
import withCountriesApollo from './with_countries_apollo';
import { ChildProps } from 'react-apollo';

interface ExternalProps {
  address: IAddress;
}

type IProps = ChildProps<ExternalProps, Countries.Query>;

const findCountry = (countryCode: string, countries: ICountry[]): ICountry => {
  return countries.find(c => c.countryCode === countryCode);
};

const countryCodeToName = (countryCode: string, countries: ICountry[]): string => {
  const country = findCountry(countryCode, countries);
  return country && country.name;
};

const regionNameInCountry = (countryCode: string, regionCode: string, countries: ICountry[]): string => {
  const country = findCountry(countryCode, countries);
  const region = country && country.subregions.find(r => (r.code === regionCode));
  return region && region.name;
};

function AddressSummary({ address, data }: IProps) {
  const { countries } = data.countries;
  const countryName = countryCodeToName(address.countryCode, countries);
  const regionName = regionNameInCountry(address.countryCode, address.region, countries);

  const {
    name,
    streetAddress,
    locality,
    region,
    postalCode,
    extendedAddress,
  } = address;

  const isIncomplete = (
    !streetAddress
      || !locality
      || !region
      || !postalCode
  );

  return (
    <div className="formatted-address">
      <p className="formatted-address__info">
        {name &&
          <>
            {name}
            <br />
          </>
        }
        {streetAddress &&
          <>
            <span className="formatted-address__highlight">
              {streetAddress}
            </span>
            <br />
          </>
        }
        {extendedAddress &&
          <>
            {extendedAddress}
            <br />
          </>
        }
        {locality && `${locality},`} {regionName} {address.postalCode}
        <br />
        {countryName}
      </p>
      {isIncomplete &&
        <p className="formatted-address__incomplete">
          {I18n.t('discovery.addressBook.addressSummary.incompleteAddress')}
        </p>
      }
    </div>
  );
}

const AddressSummaryWithCountries = withCountriesApollo<ExternalProps>(AddressSummary);
export { AddressSummary, AddressSummaryWithCountries };



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/addresses/address_summary.tsx